<template>
  <div id="video_page">
    <div class="left_part">
      <div class="left_main">

        <div class="tools_introduce">
          <img class="face_icon" :src="video_tabs2[tagNum].img2" alt="">
          <div class="introduce_main">
            <div class="introduce_title">{{ video_tabs2[tagNum].name.trim() }} - 工具箱</div>
            <div class="introduce_text">{{ video_tabs2[tagNum].title }}
            </div>
          </div>
        </div>
        <div class="form_wrap">
          <template v-if="create_type==1">
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">上传图片</div>
            </div>
            <div class="upload_wrap" v-loading="upImgloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload class="img-uploader"
                         :action="fileAPI + '/api/front/aivideo/upload/?soft=5&fdir=vmagic&key=sdf232fsdfa@3#@!'"
                         :show-file-list="false"
                         accept=".jpg,.png,.jpeg"
                         :before-upload="beforeUpload"
                         :on-success="handleUploadSuccess">
                <div class="upload_inner" flex-center v-if="userInfo.is_vip<1||!isLogin">
                  <template v-if="create_form.img_url">
                    <img class="upload_img" :src="cdn_url_replace(create_form.img_url)" alt="">
                    <i @click.stop="create_form.img_url = ''" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
                <div class="upload_inner" flex-center v-else>
                  <template v-if="create_form.img_url">
                    <img class="upload_img" :src="cdn_url_replace(create_form.img_url)" alt="">
                    <i @click.stop="create_form.img_url = ''" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
              </el-upload>
            </div>
          </template>
          <template v-else>
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">上传两张单人图片</div>
            </div>
            <div class="upload_wrap" v-loading="upImgloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload class="img-uploader" :action="fileAPI + '/api/front/aivideo/upload/?soft=1'"
                         :show-file-list="false" :before-upload="beforeUpload" accept=".jpg,.png"
                         :on-success="handleUploadSuccess">

                <div class="upload_inner" flex-center>
                  <template v-if="create_form.img_urls[tagAvt-1]!=''">
                    <img class="upload_img" :src="cdn_url_replace(create_form.img_urls[tagAvt-1])" alt="">
                    <i @click.stop="deleteImg" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
              </el-upload>
            </div>
            <div class="tendBox">
              <div :class="tagAvt == 1 ? 'tendItem tendItemAct' : 'tendItem'"
                   @mouseenter="handleMouseEnter(1)"
                   @mouseleave="handleMouseLeave"
                   @click="tagAvt = 1">
                <div class="closeTen" v-show="tenCurent == 1" @click="tenClose(1)">
                  <img src="./img/tagClose.png" alt="">
                </div>
                <el-image :src="cdn_url_replace(create_form.img_urls[0])" v-show="create_form.img_urls[0]!=''"></el-image>
                <div class="null" v-show="!create_form.img_urls[0]">
                  <img src="./img/addtag.png" alt="">
                </div>
                第一张
              </div>
              <div class="tago" @click="changeTend">
                <img src="./img/tago.png" alt="">
              </div>
              <div :class="tagAvt == 2 ? 'tendItem tendItemAct' : 'tendItem'"
                   @mouseenter="handleMouseEnter(2)"
                   @mouseleave="handleMouseLeave"
                   @click="tagAvt = 2">
                <div class="closeTen" v-show="tenCurent == 2" @click="tenClose(2)">
                  <img src="./img/tagClose.png" alt="">
                </div>
                <el-image :src="create_form.img_urls[1]" v-show="create_form.img_urls[1]!=''"></el-image>
                <div class="null" v-show="!create_form.img_urls[1]">
                  <img src="./img/addtag.png" alt="">
                </div>
                第二张
              </div>
            </div>
          </template>

          <!--          <div class="form_title">-->
          <!--            <div class="title_icon"></div>-->
          <!--            <div class="title_text">视频时长</div>-->
          <!--          </div>-->
          <!--          <div class="model_wrap">-->
          <!--            <div @click="curentTimerFn(du)"-->
          <!--                 :class="['model_item', 'select_item', { 'active': video_tabs2[tagNum].jifen == du.value }]"-->
          <!--                 flex-center-->
          <!--                 v-for="du in duration_list">{{ du.name }}-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="left_footer">
        <div :class="['primary_button', { 'disabled_btn': create_form.model == 3 }]"
             @click="clickSubmit"
             v-loading="sendLoading">
          提交任务
          <span class="fz12">（消耗{{ conSec }}积分）</span>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
    <div class="main_part">
      <div class="top_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法，严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>
<!--      <div class="create_center" ref="scrollWrap" v-infinite-scroll="loadMore"-->

<!--      <div class="create_center" ref="scrollWrap" @scroll="loadMore()">-->
              <div class="create_center" ref="scrollWrap" >
        <!--样例开始-->
        <div class="message_list"
             v-infinite-scroll="fettchSampleList"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="SampleListDisabled"
             v-if="!isLogin||video_list.length==0">
          <div class="list_item" v-for="(msg, index) in sampleSysList">
            <div class="item">
              <div class="item_touxiang">
                <img src="./img/modle_icon/cartoon.png" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      工具箱
                    </div>
                    <template>
                      <div class="item_type">
                        {{ video_tabs2[tagNum].name.trim() }}
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="sample_btn('del')">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('noDown')">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('put')">
                      <i class="el-icon-position"></i> 推荐广场
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap">
                  <div class="creating" v-if="msg.status===1">
                    <template v-if="msg.progress > 10">
                      <div class="progress">{{ msg.progress }}%</div>
                      <img class="loading_gif" src="./img/loading-new.gif">
                    </template>
                    <template v-else>
                      <img class="loading_gif" src="./img/loading-new.gif">
                      <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                    </template>
                  </div>
                  <!--                  <video controls v-else style="width: 700px;height: 400px" :src="msg.video_url"></video>-->
                  <div v-else class="success_shou">
                    <div class="success_shouVideo"
                         @click.stop="handlePlay('play',index,msg)">
                      <video playsinline="playsinline" :poster="msg.img_url"
                             preload="none" role="application" controls controlslist="nodownload"
                             :src="msg.video_url"
                             @play="handlePlay('',index)"
                             :ref="`videoPlayer${index}`"></video>
                      <div v-if="msg.img_url !=null || msg.img_url !=''" class="success_img"
                           :style="msg.img_url ==null || msg.img_url ==''?'display:none;':'display:;'">
                        <img :src="msg.img_url" alt="" class="xianshi">
                        <div class="success_imgdel">
                          <div style="display: flex;align-items: flex-end;">
                            <span style="background: #5865f2a8;border-radius: 3px;
                                margin:2px;padding: 0 4px;color: white">
                               原图
                            </span>
                          </div>
                          <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                            <i class="el-icon-close yichang" @click="msg.img_url = ''"></i>
                          </div>
                        </div>
                      </div>
                      <div :style="msg.img_url ==null || msg.img_url ==''?'display:none;':'display:;'"
                           style="position: absolute;top: 2px;left: 0;">
                        <span style="z-index: 10; background: #5865f2a8;border-radius: 3px;margin:2px;
                            padding: 3px 4px;color: white">

                          生成后
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(msg,index)" v-show="!msg.is_vote">
                      <img src="./img/zan1.png" class="zanImg" /> 赞一下
                    </div>
                    <div class="zanDetail" v-show="msg.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg" /> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ msg.votes }}个赞
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例结束-->

                <div class="message_list"
                     v-infinite-scroll="loadMore"
                     :infinite-scroll-immediate="false"
                     :infinite-scroll-disabled="noMore">
<!--        <div class="message_list">-->
          <div class="list_item" v-for="(msg, index) in video_list">
            <div class="item">
              <div class="item_touxiang">
                <img :src="require('./img/modle_icon/cartoon.png')" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      工具箱
                    </div>
                    <template>
                      <div class="item_type">
                        {{ video_tabs2[tagNum].name.trim() }}
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="deleteVideo(index, msg)">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="downloadVideo( msg,index)">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div v-if="msg.status == 2">
                      <div style="margin-left: 5px" v-if="msg.is_public==0||msg.is_public==null"
                           @click="recommend(msg.id,index)">
                        <i class="el-icon-position"></i> 推荐广场
                      </div>
                      <div style="margin-left: 5px" v-else>
                        <i class="el-icon-position"></i> 已推荐到广场
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap">
                  <div v-if="msg.status == 0">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <div class="progress">{{ msg.progress }}%</div>
                        <img class="loading_gif" src="./img/loading-new.gif">
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 1">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <div class="progress">{{ msg.progress }}%</div>
                        <img class="loading_gif" src="./img/loading-new.gif">
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2 && msg.video_url === null">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <div class="progress">{{ msg.progress }}%</div>
                        <img class="loading_gif" src="./img/loading-new.gif">
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2 && msg.video_url !== null" class="success_shou">
                    <div class="success_shouVideo"
                         @click.stop="onVideoPlay('play',index,msg)">
                      <video controls controlslist="nodownload"
                             :poster="msg.cover_url!=null?msg.cover_url:''"
                             :preload="msg.cover_url!=null?'none':'auto'" v-loading="true"
                             :src="msg.video_url"
                             :ref="`videoPlayers${index}`"
                             @play="onVideoPlay('',index)"></video>
                      <div v-if="msg.cover_url !=null || msg.cover_url !=''" class="success_img"
                           :style="msg.cover_url ==null || msg.cover_url ==''?'display:none;':'display:;'">
                        <img :src="msg.cover_url" alt="" class="xianshi">
                        <div class="success_imgdel">
                          <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:
                                 2px;padding: 0 4px;color: white">生成后</span>
                          </div>
                          <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                            <i class="el-icon-close yichang" @click="msg.cover_url = ''"></i>
                          </div>
                        </div>
                      </div>
                      <div :style="msg.cover_url ==null || msg.cover_url ==''?'display:none;':'display:;'"
                           style="position: absolute;top: 2px;left: 0;">
                        <span
                            style="z-index: 10;  background:
                             #5865f2a8;border-radius: 3px;margin: 2px;padding: 3px 4px;color: white">
                          原图
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="error_video" v-loading="msg.regenLoading > 0 "
                       v-if="msg.status == 3">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <div class="error_text2" @click="regenerate(msg,index)">点此重新生成</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4" v-if="msg.show_error">
                      失败原因： <span style="color:red;">{{msg.show_error}}</span>
                    </div>
                    <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                        :href="kefu_url"
                        target="_blank">在线客服</a></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <shibaiyuanyin ref="retryPop"></shibaiyuanyin>
  </div>

</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import shibaiyuanyin from "COMPONENTS/shibaiyuanyin.vue";
import utils from "../../utils";
import AliCdn from '../../utils/ali_cdn'

export default {
  components: {
    shibaiyuanyin,
    faceVerifyPopup,
    popup
  },
  data() {
    return {
      kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      create_form: {
        style: '',
        seconds: '5',
        img_url: '', // 单图
        img_urls: ['', ''], // 双图
      },
       cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      curentTimer: 3,
      fileAPI: API_SERVER,
      video_list: [],
      noMore: true,
      page: 1,
      size: 20,

      timer: null,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      fileApi: API_SERVER,
      conSec: 50,
      duration_list: [
        {
          name: '5秒',
          value: 5,
        },
        {
          name: '10秒',
          value: 10,
        },
      ],
      upVidleloading: false,
      upImgloading: false,

      video_tabs2: [
        {
          name: '花花世界  ',
          tag2: 'bloombloom',
          types: '/kelingTool?plan=bloombloom&loca=1',
          jifen: 5,// 积分
          title: '上传照片，先生成属于你的开花图片。主体物明确、轮廊清晰的照片效果最佳',// 简介
          img2: require('../components/img/side/kelingTool/01.gif'),
        },
        {
          name: '魔力转圈圈',
          tag2: 'dizzydizzy',
          types: '/kelingTool?plan=dizzydizzy&loca=2',
          jifen: 5,// 积分
          title: '魔力转圈圈可以应用于单图特效，为静态图片添加动态旋转效果',// 简介
          img2: require('../components/img/side/kelingTool/02.gif'),
        },
        {
          name: '快来惹毛我',
          tag2: 'fuzzyfuzzy',
          types: '/kelingTool?plan=fuzzyfuzzy&loca=3',
          jifen: 5,// 积分
          title: '只需上传一张以人物或物品为主体的图片，即可生成具有“反差萌”效果的创意视频',// 简介
          img2: require('../components/img/side/kelingTool/03.gif'),
        },
        {
          name: '捏捏乐   ',
          tag2: 'squish',
          types: '/kelingTool?plan=squish&loca=4',
          jifen: 5,// 积分
          title: '上传一张以人物或物品为主体的图片，即可生成具有柔软、Q弹效果的动态视频',// 简介
          img2: require('../components/img/side/kelingTool/04.gif'),
        },
        {
          name: '万物膨胀 ',
          tag2: 'expansion',
          types: '/kelingTool?plan=expansion&loca=5',
          jifen: 5,// 积分
          title: '通过夸张的膨胀效果，为原本普通的图像增添了诙谐和反差萌的视觉效果',// 简介
          img2: require('../components/img/side/kelingTool/05.gif'),
        },
        {
          name: '一键变手办 ',
          tag2: 'Labubu Style',
          types: '/kelingTool?plan=Labubu Style&loca=5',
          jifen: 5,// 积分
          title: '将用户上传的照片转换成具有手办风格的图像或3D模型。生成的手办形象通常具有夸张的特征、鲜明的色彩和精致的细节，呈现出独特的视觉效果',// 简介
          img2: require('../components/img/side/kelingTool/06.gif'),

        },
        {
          name: '一键拍立得 ',
          tag2: 'Magic Polaroid',
          types: '/kelingTool?plan=Magic Polaroid&loca=5',
          jifen: 5,// 积分
          title: '用户只需上传一张照片，即可快速生成具有3D立体感和拍立得风格的动态视频效果',// 简介
          img2: require('../components/img/side/kelingTool/07.gif'),

        },
        {
          name: '拥抱    ',
          tag2: 'hug',
          types: '/kelingTool?plan=hug&loca=6',
          jifen: 5,// 积分
          title: '适用于情侣、朋友等双人互动场景，能够为视频创作增添温馨、亲密的氛围',// 简介
          img2: require('../components/img/side/kelingTool/08.gif'),

        },
        {
          name: '亲吻    ',
          tag2: 'kiss',
          types: '/kelingTool?plan=kiss&loca=7',
          jifen: 5,// 积分
          title: '能够生成自然且流畅的亲吻动作，让静态图片瞬间“动起来”，效果逼真',// 简介
          img2: require('../components/img/side/kelingTool/09.gif'),

        },
        {
          name: '比心    ',
          tag2: 'heart_gesture',
          types: '/kelingTool?plan=heart_gesture&loca=8',
          jifen: 5,// 积分
          title: '适合用于表达爱意、祝福等情感的视频创作，能够营造出浪漫或友好的氛围',// 简介
          img2: require('../components/img/side/kelingTool/10.gif'),

        },
      ],
      tagNum: 0,
      create_type: 1,
      select_rec_img: {
        img_url: ''
      },
      tagAvt: 1,
      tenCurent: 0,
      tenImg: '',
      SampleListDisabled:true,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    kelingTool() {
      return this.$store.state.kelingTool;
    },
  },
  created() {
    if (!this.kelingTool) {
      console.log('nokelingTool')
      this.$store.commit('setkelingTool', 'bloombloom');
    }
    this.video_tabs2.forEach((item, index) => {
      if (item.tag2 == this.kelingTool) {
        this.tagNum == index
      }
    })

    this.create_form.img_url = ''
    this.create_form.img_urls = ['', '']

    this.fetchVideoList()
    // this.fettchSampleList()
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null
    }
  },
  methods: {
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      return url.replace(o_url, c_url)
    },

    handleMouseEnter(data) {
      this.tenCurent = data
    },
    deleteImg() {
      this.create_form.img_urls[this.tagAvt - 1] = ''
    },
    changeTend() {
      if (this.create_form.img_url && this.create_form.img_urls == '') {
        this.definition = [{name: '高清', value: 0},]
        this.create_form.is_hd = 0
        let par = this.create_form.img_url
        this.create_form.img_urls = par
        this.create_form.img_url = ''
        this.setScore()
      } else if (this.create_form.img_urls && this.create_form.img_url == '') {
        this.definition = [{name: '标清', value: 0},
          {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        let par = this.create_form.img_urls
        this.create_form.img_url = par
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        let par = this.create_form.img_url
        this.create_form.img_url = this.create_form.img_urls
        this.create_form.img_urls = par
      }
      this.tenImg = this.tagAvt == 1 ? this.create_form.img_url : this.create_form.img_urls
    },
    tenClose(data) {
      this.create_form.img_urls[data - 1] = ''
    },

    handleMouseLeave() {
      this.tenCurent = 0
    },

    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    fettchSampleList() {
      this.SampleListDisabled = true
      // 获取样例数据
      this.$http.get('/front/aivideo/tool/sample/', {
        params: {
          page: this.page,
          page_size: 5,
          style: this.kelingTool,
        }
      }).then((res) => {
        this.page++
        this.SampleListDisabled=false
        if(res.data.list.length<5){
          this.SampleListDisabled=true
          // this.$message.warning('样例已全部加载')
        }
        this.sampleSysList = this.sampleSysList.concat(res.data.list)
      })
    },


    fetchVideoList() {

      this.$http.get(`/front/aivideo/tool/`, {
        params: {
          page: this.page,
          page_size: 20,
          style: this.kelingTool,
        }
      }).then(res => {
        if (res.status == '200') {
          this.noMore = false
          // this.video_list = res.data.item_list
          res.data.length < 20 ? this.size = res.data.length : this.size
          if (res.data.length > 0) {
            this.page++
            this.video_list = this.video_list.concat(res.data)
            res.data.forEach(e => {
              if (e.status <= 1 || (e.status == 2 && e.video_url == "")) {
                this.checkIds.push(e.id)
              }
            })
            if (this.checkIds.length > 0) {
              this.fetchMsg()
            }
          } else {
            this.noMore = true
            if(this.page == 1){
              this.fettchSampleList()
            }
          }
        }else{
          this.fettchSampleList()
        }
      }).finally(() => {
      })
    },
    fetchMsg() {
      console.log(this.checkIds)
      if (this.checkIds.length === 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/tool/check/', {ids: this.checkIds}).then((res) => {
          if (res.status === "200") {
            let item_list = res.data.item_list;
            let _id = 0;
            item_list.forEach(e => {
              _id = e.id
              let item = this.video_list.filter((obj) => obj.id === _id)[0];
              item.status = e.status
              item.is_public = 0
              item.img_url = e.img_url
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 100
              } else {
                item.progress += num
              }
              if (e.status > 2) {
                // 删除生成成功或失败的
                this.checkIds = this.checkIds.filter(i => i !== _id)
              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== _id)
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                item.video_url = e.local_video_url
                console.log(item.video_url)
                item.cover_url = e.cover_url
                item.img_url = e.img_url
                item.regenLoading = 0
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                item.show_error = e.show_error
                if(e.show_error){
                  this.$message.error(e.show_error)
                }
                this.video_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.video_list[num] = e
                  }
                })
              }
            })
          }
          if (this.checkIds.length === 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 5000)
    },
    clickSubmit() {
      if (!this.checkLogin()) {
        return
      }
      if(SITE_BTN_CONFIG.bnt_kling_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }
      console.log('判断视频进入')
      let num = 0
      this.create_form.img_urls.forEach(e => {
        e == '' ? num++ : num
      })
      if (this.create_type == 1) {
        if (this.create_form.img_url == "") {
          this.$message.warning('请上传图片')
          return
        }
      } else {
        let num = 0
        this.create_form.img_urls.forEach(e => {
          e == '' ? num++ : num
        })
        if (num != 0) {
          this.$message.warning('请上传两张单人图片')
          return
        }
      }


      this.sendLoading = true
      let create_data = {
        style: this.kelingTool,
        seconds: '5',
        img_url: '', // 单图
        img_urls: ['', ''], // 双图
      }

      if (this.create_type == 1) {
        create_data.img_url = this.create_form.img_url
        create_data.img_urls = []
      } else {
        create_data.img_url = ''
        create_data.img_urls = this.create_form.img_urls
      }
      console.log(create_data)
      // return;

      this.$http.post('/front/aivideo/tool/',
          {
            data: create_data,
            tool_type: this.kelingTool,
          }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          let video = res.data
          video.status = 0
          this.video_list.unshift(video);
          this.checkIds.push(video.id)
          this.fetchMsg()
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err => {
        console.log(err)
        this.$message({
          message: err.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },

    loadMore() {
      this.noMore = true

      this.fetchVideoList()

    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/Vmagic/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.video_list.splice(index, 1)
            if(this.video_list==[]){
              this.page = 1
              this.fetchVideoList()
            }
          }
        })
      }).catch(() => {
      });
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    handleUploadSuccess(res, file) {
      this.upImgloading = false
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
        return
      }
      // 判断是否是单双人
      if (this.create_type == 1) {
        this.create_form.img_url = res.data.file_full_url
      } else {
        if (this.tagAvt == 1) {
          this.create_form.img_urls[0] = res.data.file_full_url
        } else {
          this.create_form.img_urls[1] = res.data.file_full_url
        }
      }
      console.log('chengong', this.create_form.img_url)
    },
    beforeUpload(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      // 文件大小限制：不能超过10MB
      const isLt10M = file.size / 1024 / 1024 < 10;
      // 文件类型限制：JPG/JPEG/PNG/BMP
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const {width, height} = img;
          // 宽高尺寸限制：不小于300px
          const isValidResolution = width >= 300 && height >= 300;
          // 宽高比限制：介于1:2.5到2.5:1之间
          const aspectRatio = width / height;
          const isValidAspectRatio = aspectRatio >= 0.4 && aspectRatio <= 2.5;

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({isValidType: false});
            return;
          }
          if (!isLt10M) {
            this.$message.error('图片文件大小不能超过10MB!');
            reject({isLt10M: false});
            return;
          }
          if (!isValidResolution) {
            this.$message.error('图片宽高尺寸不能小于300px!');
            reject({isValidResolution: false});
            return;
          }
          if (!isValidAspectRatio) {
            this.$message.error('图片宽高比必须介于1:2.5到2.5:1之间!');
            reject({isValidAspectRatio: false});
            return;
          }

          this.upImgloading = true;
          resolve({isValidType, isLt10M, isValidResolution, isValidAspectRatio});
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({isImageValid: false});
        };
      });

    },
    recommend(video_id, index) {
      console.log(video_id)
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      let data
      //   sys_cae_id:1

      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.video_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        console.log(res)
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {

      })
    },
    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }
      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      }  else if (name == 'noDown') {
        this.$message({
          message: '样例数据不能下载！请创作后重试。',
          type: 'warning'
        });
      }else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(type,currentIndex,item) {
      this.$nextTick(() => {
        if(type == 'play'){
          if(item.dainjizanting){
            return
          }
          this.sampleSysList.forEach((video, index) => {
            if (index == currentIndex) {
              video.dainjizanting = true
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayer${index}`][0]
              if(videoElement.paused){
                videoElement.play()
              }else{
                videoElement.pause()
              }
            }
          });
        }else{
          this.sampleSysList.forEach((video, index) => {
            if (index !== currentIndex) {
              // 暂停其他视频
                // 暂停其他视频
                const videoElement = this.$refs[`videoPlayer${index}`][0];
                videoElement.pause();
            }
          });
        }

      });
    },
    onVideoPlay(type,currentIndex,item) {
      if(type == 'play'){
        if(item.dainjizanting){
          return
        }
        this.video_list.forEach((video, index) => {
          if (index == currentIndex) {
            video.dainjizanting = true
            // 暂停其他视频
            const videoElement = this.$refs[`videoPlayers${index}`][0]
            if(videoElement.paused){
              videoElement.play()
            }else{
              videoElement.pause()
            }
          }
        });
      }else{
        this.video_list.forEach((video, index) => {
          if (index !== currentIndex) {
            // 暂停其他视频
            if (video.status == 2) {
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayers${index}`][0];
              videoElement.pause();
            }
          }
        });
      }

    },
    regenerate(item, index) {
      console.log(item)
      console.log(JSON.parse(item.ingredients))
      console.log('重新生成')
      // return
      this.create_form = JSON.parse(item.ingredients)
      this.clickSubmit()
    },
    tozanFn(data,ind){
      console.log(data)
      this.$http.put(`/front/aivideo/tool/sample/`,
      {
          id:data.id
        }
      ).then(res=>{
        data.votes++
        data.is_vote = 1
        const clickedItem = this.sampleSysList[ind];
        this.sampleSysList.splice(ind, 1); // 删除原位置的元素
        this.sampleSysList.unshift(clickedItem); // 插入到数组开头
      }).catch((err)=>{
        console.log('走错误');
        if (!this.isLogin) {
          this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        }else{

        }
      })
    },
    downloadVideo(is_video,index ) {
      if (!this.checkLogin()) {
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }else{
          let message = res.message;
          utils.createErrTip(message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
  watch: {
    '$store.state.kelingTool': function (newVal, oldVal) {
      console.log('切换')
      if (newVal !== oldVal) {
        this.page = 1
        this.video_tabs2.forEach((item, index) => {
          if (item.tag2 == this.kelingTool) {
            this.tagNum = index
            this.conSec = 50
            this.sampleSysList = []  // 系统样例
            this.video_list = []
            this.fetchVideoList()
            this.fettchSampleList()
            console.log('this.tagNum111', this.tagNum)
            this.create_form = {
              seconds: '5',
              img_url: '', // 单图
              img_urls: ['', ''], // 双图
            }
            this.checkIds = []
            if (newVal == 'hug' || newVal == 'kiss' || newVal == 'heart_gesture') {
              this.create_type = 2
            } else {
              this.create_type = 1
            }
          }
        })
      }

    }
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#video_page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #fff;
  background-color: rgb(49, 51, 56);
  display: flex;
  font-size: 14px;

  .left_part {
    width: 350px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-color: rgb(43, 45, 49);

    .left_main {
      padding: 10px;
      overflow: hidden;
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;

      .left_tabs {
        display: flex;
        border: 1px solid rgb(54, 55, 61);
        background-color: rgb(49, 51, 56);
        margin-bottom: 10px;
        padding: 4px;
        height: 40px;
        gap: 4px;
        border-radius: 6px;

        .tab_item {
          font-size: 13px;
          border-radius: 4px;
          cursor: pointer;
          flex: 1 1 0%;

          &.active {
            background-color: #5865F2;
          }
        }
      }

      .tools_introduce {
        padding: 20px 20px;
        display: flex;
        border-radius: 6px;
        overflow: hidden;
        background-color: rgb(30, 31, 34);

        .face_icon {
          width: 100px;
          height: auto;
          margin-right: 15px;
        }

        .introduce_main {
          flex-grow: 1;

          .introduce_title {
            font-size: 14px;
            line-height: 19px;
            font-weight: 700;
          }

          .introduce_text {
            font-size: 12px;
            line-height: 19px;
            margin-top: 5px;
            color: #ccc;
          }
        }

      }

      //.tools_introduce {
      //  border-radius: 6px;
      //  background-color: rgb(30, 31, 34);
      //  padding: 16px 14px;
      //  display: flex;
      //
      //  .face_icon {
      //    width: 20px;
      //    height: 20px;
      //    margin-right: 10px;
      //    border: none;
      //  }
      //
      //  .introduce_main {
      //    flex-grow: 1;
      //
      //    .introduce_title {
      //      font-size: 14px;
      //      line-height: 19px;
      //      font-weight: 700;
      //    }
      //
      //    .introduce_text {
      //      font-size: 12px;
      //      line-height: 19px;
      //      margin-top: 5px;
      //    }
      //  }
      //}

      .form_wrap {
        flex: 1 1 0%;
        overflow-y: auto;

        .form_title {
          margin: 12px 0;
          display: flex;

          .title_icon {
            border-radius: 3px;
            //height: 15px;
            width: 4px;
            background-color: #5865F2;
          }

          .title_text {
            flex-grow: 1;
            margin-left: 6px;
          }
        }

        .upload_wrap {
          height: 140px;
          font-size: 20px;
          border: 1px dashed #42464e;
          position: relative;
          border-radius: 6px;
          overflow: hidden;

          &:hover {
            border-color: #5865f2;
          }

          :deep(.el-upload-dragger) {
            width: 100%;
            height: 100%;
            background: #1d2027;
            padding: 0;
            border-radius: 6px;
            border: none;
          }


          .upload_inner {
            width: 100%;
            height: 100%;
            flex-direction: column;

            .el-icon-plus {
              margin-bottom: 8px;
              font-size: 30px;
              font-weight: bold;
              color: rgb(192, 196, 204);
            }

            .upload_text {
              font-size: 14px;
              text-align: center;
              color: #606266;
              line-height: 20px;
            }

            .upload_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              border: none;
            }

            .el-icon-delete {
              position: absolute;
              cursor: pointer;
              color: #fff;
              right: 12px;
              bottom: 12px;
              font-size: 16px;
            }
          }
        }


        .select_item {
          font-size: 13px;
          background-color: #1d2027;
          border-radius: 4px;
          border: 2px solid #1d2027;
          cursor: pointer;

          &.active {
            border-color: #5865f2;
            background-color: rgba(88, 101, 242, 0.15);
          }
        }

        .model_wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 5px;

          .model_item {
            position: relative;
            width: 77px;
            height: 40px;

            .need_vip {
              position: absolute;
              color: #f0b132;
              line-height: 17px;
              font-weight: 700;
              top: -10px;
              right: 0;
            }
          }
        }

        .tendBox {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          border: 1px dashed rgb(66, 70, 78);
          border-top: 0;
          padding: 0 20px;

          .tendItem {
            width: 130px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px 0 5px;
            cursor: pointer;
            position: relative;
            border: 1px solid rgb(66, 70, 78);
            border-radius: 6px;

            .closeTen {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 18px;
              height: 18px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .null {
              width: 30px;
              height: 30px;
            }

            .el-image {
              width: 32px;
              height: 32px;
            }
          }

          .tendItemAct {
            border: 1px solid rgb(88, 101, 242);
          }

          .tago {
            width: 20px;
            height: 20px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            margin: 0 10px;
          }
        }


      }
    }

    .left_footer {
      border-top: 1px solid #42464e;
      padding: 15px 30px 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      .primary_button {
        font-size: 16px;
        height: 46px;
        border-radius: 23px;
        width: 100%;

        /deep/ .el-loading-mask {
          background: none;
        }

        &.disabled_btn {
          cursor: not-allowed;
          background-color: #393b3f;
          user-select: none;
          color: #999;
        }
      }
      .screen{
        color:#666;
        text-align: center;
        margin: 10px 0;
        font-size: 12px;
      }
    }
  }

  .main_part {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;

    .top_tips {
      height: 48px;
      padding: 0 16px;
      border-bottom: 1px solid #26282c;
      display: flex;
      align-items: center;

      .one {
        font-size: 18px;
        color: #949ba4;
      }

      .two {
        font-size: 16px;
        color: #fff;
        margin: 0 10px;
        white-space: nowrap;
      }

      .three {
        font-size: 12px;
        color: #f0b132;
      }
    }

    .create_center {
      flex: 1 1 0%;
      padding-right: 5px;
      overflow-y: auto;

      .message_list {
        // height: 100%;
        // overflow: hidden;
        // overflow-x: hidden;
        padding-bottom: 10px;
        overflow-y: auto;

        .list_item {
          margin: 10px 10px 10px 0;
          background-color: #403d38;
          border-left: 2px solid #f0b132;
          padding: 20px;
          overflow: hidden;
          word-break: break-all;
          white-space: normal;
          line-height: 20px;

          .item {
            display: flex;

            .item_touxiang {
              width: 50px;
              margin-right: 10px;

              img {
                width: 48px;
                height: 48px;
              }
            }
          }

          .item_right {
            flex: 1 0;
          }

          .item_top {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;

            .top_left {
              display: flex;
              align-items: center;

              .item_type {
                //height: 24px;
                padding: 2px 12px;
                margin: 0 8px;
                background-color: #4b5196;
                border-radius: 4px;
                white-space: nowrap;
              }

              .item_time {
                white-space: pre-wrap;
                color: #707070;
              }
            }

            .top_right {
              display: flex;
              align-items: center;
              white-space: nowrap;
              margin-left: 8px;
              color: #949ba4;
              cursor: pointer;

              div:hover {
                color: #fff;
              }

              .el-icon-delete {
                font-size: 14px;
                margin-right: 3px;
              }
            }
          }

          .msg_text {
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .split_line {
            margin: 10px 0;
            height: 1px;
            background-color: #555041;
          }

          .msg_desc {
            color: #99916b;
          }

          .video_wrap {
            margin-top: 10px;
            position: relative;

            .tozan{
              -webkit-user-select: none;
              /* Safari */
              -moz-user-select: none;
              /* Firefox */
              -ms-user-select: none;
              /* IE10+/Edge */
              user-select: none;
              display: flex;
              flex-direction: column;
              align-items: end;
              position: absolute;
              right: 0;
              top: 10px;
              .zanOne{
                width:90px;
                height:30px;
                display: inline-flex;
                line-height: 30px;
                background-color: #ffffff; /* 背景颜色 */
                color: #000; /* 文字颜色 */
                border: none;
                border-radius: 3px; /* 圆角 */
                font-size: 14px;
                cursor: pointer;
                box-shadow: 0 0 8px rgba(255, 255, 255,.1), 0 0 10px rgba(255, 255, 255,.2), 0 0 10px rgba(255, 255, 255,.5); /* 荧光效果 */
                .zanImg{
                  width:18px;
                  height:18px;
                  margin:0 10px;
                  font-size:0;
                  margin-top: 5px;
                }
              }
              .zanTex{
                font-size: 14px;
                color: #99916b;
                margin:15px 0;
              }
              .zanTwo{
                color: #f0b53e; /* 文字颜色 */
                box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255,.5); /* 荧光效果 */
                cursor:auto;
              }
            }
            .creating {
              position: relative;

              .loading_text {
                padding-left: 12px;
                color: #f0b132;
              }

              .progress {
                font-weight: 700;
                font-size: 13px;
                width: 100px;
                padding-top: 40px;
                margin: 20px;
                color: #000;
                text-align: center;
                z-index: 1;
                position: absolute;
              }

              .loading_gif {
                width: 100px;
                margin: 20px;
                display: block;
                border: none;
              }
            }

            //失败
            .error_video {
              width: 190px;
              //height: 190px;
              background-color: #fff;
              border-radius: 4px;
              padding: 14px 10px;
              text-align: center;
              font-size: 14px;
              margin-top: 20px;

              .error_icon {
                display: block;
                width: 35px;
                margin: 0 auto;
              }

              .error_text {
                color: #ccc;
                //line-height: 64px;
                margin: 10px 0 36px;
              }

              .error_text2, .error_text3 {
                font-size: 12px;
                color: #56b15b;
              }

              .error_text2 {
                cursor: pointer;
                margin-bottom: 5px;
              }

              .error_text3 {
                color: #ccc;
                margin-bottom: 36px;
              }

              .error_text4 {
                font-size: 12px;
                color: #ccc;
                line-height: 1.8;

                a {
                  color: red;
                }
              }

              .error_btn {
                display: inline-block;
                cursor: pointer;
                color: #ffab46;
                padding-top: 15px;
              }
            }


            .success_shou {
              display: flex;

              .icon_you {
                width: 50px;
              }

              .success_shouVideo {
                position: relative;
                width: 700px;
                height: 400px;
                background-color: #080707;

                video {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%; /* 设置视频宽度为父容器的100% */
                  height: 100%; /* 保持视频的宽高比 */
                }

                .success_img {
                  position: absolute;
                  display: inline-block;
                  top: 5px;
                  right: 5px;
                  border: 1px solid #FFF;

                  img {
                    display: block;
                    width: 100px; /* 根据需要调整图片宽度 */
                    height: auto;
                    cursor: pointer;
                  }

                  img:hover .success_imgdel {
                    position: absolute;
                    top: 0; /* 调整图标距离顶部的距离 */
                    right: 0; /* 调整图标距离右侧的距离 */
                    border-radius: 50%; /* 使图标背景为圆形 */
                    font-size: 18px; /* 根据需要调整图标字体大小 */
                    color: #333; /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;
                  }

                  .success_imgdel {
                    position: absolute;
                    top: 0; /* 调整图标距离顶部的距离 */
                    right: 0; /* 调整图标距离右侧的距离 */
                    border-radius: 50%; /* 使图标背景为圆形 */
                    font-size: 18px; /* 根据需要调整图标字体大小 */
                    color: #333; /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;

                    span {
                      font-size: 12px;
                    }

                    i {
                      font-size: 12px;
                      background-color: #fff;
                      border-radius: 50%;
                    }
                  }

                  .success_imgdel:hover {
                    color: white;

                    i {
                      font-size: 12px;
                      background-color: #2b2d31;
                      border-radius: 50%;
                    }
                  }

                }
              }

              .success_img:hover {
                .success_imgdel {
                  display: flex;
                }
              }
            }
          }
        }
      }
    }
  }

  .img-uploader {
    width: 100%;
    height: 100%;

    :deep(.el-upload) {
      width: 100%;
      height: 100%;
    }
  }
}

.desc_popover {
  color: #b5bac1;

  .desc_popover_top {
    padding: 4px 4px 10px;
  }

  .recommend_list {
    height: 300px;
    overflow-y: auto;

    li {
      border-radius: 3px;
      padding: 10px 8px;
      cursor: pointer;
      display: flex;

      &:hover {
        background-color: rgb(43, 45, 49);
      }

      .rec_img {
        height: 34px;
        width: 48px;
        margin-right: 8px;
        display: block;
        border: none;
      }

      .rec_text {
        flex: 1 1 0%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;

        .rec_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rec_desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.recommend_dialog {
  width: 470px;
  color: #fff;

  .el-icon-error {
    position: absolute;
    color: #707072;
    font-size: 16px;
    top: 10px;
    right: 15px;
    cursor: pointer;
    padding: 6px;
  }

  .dialog_title {
    font-size: 16px;
    height: 54px;
    padding: 0 20px;
    background-color: #2B2D31;
    display: flex;
    align-items: center;
  }

  .dialog_body {
    font-size: 13px;
    padding: 20px;

    .body_title {
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      .title_icon {
        border-radius: 3px;
        height: 15px;
        width: 4px;
        background-color: #5865F2;
      }

      .title_text {
        flex-grow: 1;
        margin-left: 6px;
      }
    }

    .img_wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .img_item {
        border-radius: 6px;
        width: 100px;
        height: 82px;
        border: 2px solid #282d31;
        overflow: hidden;
        cursor: pointer;
        position: relative;

        &.active {
          border-color: #5865f2;
        }

        .rec_img {
          display: block;
          border: none;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .img_name {
          position: absolute;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.56);
          height: 23px;
          font-size: 12px;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upload_tips {
      margin: 10px 0;
      color: #6e6e6e;
      user-select: none;
      display: flex;
      align-items: center;

      .vip_tag {
        font-weight: 700;
        color: #f0b132;
      }
    }

    .upload_wrap {
      height: 100px;
      color: #8e9093;
      background-color: #1d2027;
      border: 1px dashed #42464e;
      cursor: pointer;

      .result_wrap {
        width: 100%;
        height: 100%;

        .upload-demo {
          height: 100%;
          width: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 100px;
        }
      }

      .show_img {
        position: relative;
        width: 100%;
        height: 100%;

        .select_img {
          height: 100%;
          display: block;
          border: none;
        }

        .el-icon-delete {
          position: absolute;
          right: 10px;
          bottom: 10px;
          cursor: pointer;
          font-size: 16px;
        }
      }

      .no_img {
        width: 100%;
        flex-direction: column;
        height: 100%;
        color: #8e9093;

        .upload_icon {
          font-weight: 700;
          font-size: 30px;
        }
      }
    }

    .dialog_footer {
      margin-top: 10px;
      gap: 10px;

      .footer_btn {
        border-radius: 4px;
        height: 38px;
        width: 180px;
      }
    }
  }
}

.el-message-box__btns button span {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 70px;
  height: 50px;
  border-radius: 50%;
  margin-right: 7px;
  cursor: pointer;
}

.fusionStyle {
  .fusionStyle_one {
    //height: 54px;
    width: 100%;
    border: 1px solid #393d45;
    border-radius: 6px;
    background-color: #1d2027;
    padding: 10px 10px;
    font-size: 12px;
    color: #abb0b6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    img {
      width: 120px;
      height: 70px;
    }

  }

  .fusionStyle_two {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .two_Imgs {
      width: 130px;
      height: 100px;
      background-color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      border-radius: 8px;

      .two_Img {
        width: 130px;
        height: 70px;
        white-space: nowrap;
        position: relative;

        img {
          width: 100%;
          height: 70px;
          object-fit: cover;
        }

        .closes {
          position: absolute;
          top: 0;
          right: 0;
          width: 25px;
          height: 25px;
          border-bottom-left-radius: 6px;
          background-color: #0000007a;
          cursor: pointer;
          padding: 0 5px;
          // 穿透更改图标大小
          /deep/ i.el-icon-error {
            font-size: 16px;
            color: #b4afb0;
            line-height: 25px;

          }

          /deep/ i.el-icon-error:hover {
            font-size: 16px;
            color: #ffffff;
          }
        }

        .title {
          width: 100%;
          font-size: 12px;
          background-color: #000000ba;
          text-align: center;
          padding: 5px 0;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }

      .two_bot {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 30px;

        div:nth-child(1) {
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
        }

        div:nth-child(3) {
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
        }
      }
    }

  }
}

.loraStyle {
  width: 435px;
  height: 450px;
  padding: 0;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 5px;

  .loraStyle_top {
    padding: 15px 10px;
    display: flex;
    background-color: #2b2d31;
    justify-content: space-between;

    i {
      cursor: pointer;
    }

    i:hover {
      color: #5865f2;
    }
  }

  .loraStyle_List {
    padding: 0 7px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    overflow-y: auto;
    gap: 5px 10px;
    height: 390px;

    .styleImg_item {
      width: 130px;
      height: 100px;
      position: relative;
      border: 2px solid rgba(88, 101, 242, 0);
      border-radius: 5px;
      overflow: hidden;
      //margin: 2px 0;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      div {
        width: 100%;
        padding: 2px 0;
        text-align: center;
        font-size: 12px;
        background-color: rgba(0, 0, 0, .6745098039215687);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }

    .styleImg_items {
      width: 130px;
      height: 100px;
      position: relative;
      border: 2px solid #5865f2;
      border-radius: 5px;
      overflow: hidden;
      //margin: 2px 0;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      div {
        width: 100%;
        padding: 2px 0;
        text-align: center;
        font-size: 12px;
        background-color: rgba(0, 0, 0, .6745098039215687);
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }
}

</style>